Alpine.data('SevenHeader', (homeUri) => ({
    isCurrentPage(path) {
        const currentPath = window.location.pathname;

        if (path === homeUri) {
            return currentPath === homeUri;
        }

        return currentPath.startsWith(path);
    }
}));